import { useEffect } from "react";
import { 
  fetchSettingsRequest, 
  receivePublicSettings,
  receivePrivateSettings,
  // receiveSettingsError 
} from "../actions/settings";
import { default as settingsService } from "../services/settings";
import { fetchProfile } from "../../../actions/profile";
import { Settings } from "../types/settings";
import { mergeWith, isArray } from "lodash";
import { default as FileSettings } from "../../../settings";
import { useAppDispatch, useAppSelector } from "@/hooks";
interface IReduxSettings {
  publicData: Settings | null;
  privateData: Settings | null;
  isFetching: boolean;
  loaded: boolean;
  error: boolean;
}

const useSettingsProvider = () => {

  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(state => state.auth?.isAuthenticated);
  const settings = useAppSelector(state => state.settings) as IReduxSettings;

  const readLocalSettingsFile = () => {
    return FileSettings as Settings;
  }

  const mergeCustomizer = (objValue: unknown, srcValue: unknown) => {
    if (isArray(srcValue)) {
      return srcValue
    }
    else if (isArray(objValue)) {
      return objValue
    }
  }

  const fetchSettings = () => {
    dispatch(fetchSettingsRequest())
    settingsService.fetchSettings()
    .then(res => {
      const localSettings = readLocalSettingsFile();
      const newSettings = mergeWith({}, localSettings, res, mergeCustomizer)
      dispatch(receivePublicSettings(newSettings));
    }).catch(err => {
      const localSettings = readLocalSettingsFile();
      dispatch(receivePublicSettings(localSettings))
    })
  }

  const fetchUserSettings = () => {
    dispatch(fetchSettingsRequest())
    settingsService.fetchUserSettings()
    .then(res => {
      const localSettings = readLocalSettingsFile();
      const newSettings = mergeWith({}, localSettings, res, mergeCustomizer)
      dispatch(receivePrivateSettings(newSettings));
    }).catch(err => {
      const localSettings = readLocalSettingsFile();
      dispatch(receivePrivateSettings(localSettings))
    })
  }

  useEffect(() => {
    if (settings.publicData == null) {
      fetchSettings()
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchProfile());
      fetchUserSettings();
    }

  }, [isAuthenticated]);

  return {
    settings
  }
  
}

export default useSettingsProvider;